// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ru","text":"rv","subText":"rw","toggleContainer":"rx","checked":"ry"};